import { ComponentPropsWithRef } from 'react';
import styles from './button.module.css';

export interface ButtonProps extends ComponentPropsWithRef<'button'> {
  primary?: boolean;
  size?: 'small' | 'medium' | 'large';
  label: string;
  onClick?: () => void;
}

const Button = ({
  primary = false,
  size = 'medium',
  label,
  ...props
}: ButtonProps) => {
  const mode = primary ? styles['button--primary'] : styles['button--secondary']
  const buttonSize = styles[`button--${size}`];

  return (
    <button
      type="button"
      className={`${styles.button} ${buttonSize} ${mode}`}
      {...props}
    >
      <span>{label}</span>
    </button>
  );
};

export default Button;
